import React from "react";

export interface ArrowRightProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const ArrowRight: React.FC<ArrowRightProps> = ({
  width = 38,
  height = 24,
  fill = "#0D6051",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37.0607 13.0607C37.6464 12.4749 37.6464 11.5251 37.0607 10.9393L27.5147 1.3934C26.9289 0.807617 25.9792 0.807617 25.3934 1.3934C24.8076 1.97919 24.8076 2.92894 25.3934 3.51472L33.8787 12L25.3934 20.4853C24.8076 21.0711 24.8076 22.0208 25.3934 22.6066C25.9792 23.1924 26.9289 23.1924 27.5147 22.6066L37.0607 13.0607ZM-2.98694e-07 13.5L36 13.5L36 10.5L2.98694e-07 10.5L-2.98694e-07 13.5Z"
      fill={fill}
    />
  </svg>
);
